module.exports = __webpack_public_path__ + "img/opet-infographic-01.2414e56b.jpg";